import Preview from '../../../../components/preview';

export default Preview;
